import { Card, Typography } from "@mui/material";

const MaintenancesCard = ({ data, subtitle = "", size = 100 }) => {

function computeMaintenanceScheduleForCurrentYear(nextMaintenance) {

  if (!nextMaintenance) return [];
  const schedule = [];
  let date = new Date(nextMaintenance);
    for(let i=0; i<2; i++)
    {
    schedule.push(new Date(date));
    date.setMonth(date.getMonth() + 6);
  }
  return schedule;
}


    let events = [];
    data.forEach((item) => {
    const nextMaintenance = item.content.next_maintenance;
    const siteSchedule = computeMaintenanceScheduleForCurrentYear(nextMaintenance);
    siteSchedule.forEach((date) => {
      events.push({
        site: item.content.name,
        date,
        siteUrl: item.content.siteUrl,
        environnement: item.content.environnement,
      });
    });
  });

  events.sort((a, b) => a.date.getTime() - b.date.getTime());

  const now = new Date();
  const minYear = Math.min(
    now.getFullYear(),
    ...(events.length ? events.map(e => e.date.getFullYear()) : [now.getFullYear()])
  );

  const maxTime = events.length ? Math.max(...events.map(e => e.date.getTime())) : now.getTime();
  const endDate = new Date(maxTime);
  endDate.setFullYear(endDate.getFullYear() + 1);
  const endYear = endDate.getFullYear();
  const endQuarter = Math.floor(endDate.getMonth() / 3) + 1;

  const groups = {};
  for (let y = minYear; y <= endYear; y++) {
    for (let q = 1; q <= 4; q++) {
      if (y === endYear && q > endQuarter) break;
      groups[`${y}-Q${q}`] = [];
    }
  }

  events.forEach((ev) => {
    const key = `${ev.date.getFullYear()}-Q${Math.floor(ev.date.getMonth() / 3) + 1}`;
    if (!groups[key]) groups[key] = [];
    groups[key].push(ev);
  });

  Object.keys(groups).forEach(k => {
    groups[k].sort((a, b) => a.date - b.date);
  });

const currentQuarter = Number.isInteger((now.getMonth()+1)/3) ? (Math.trunc((now.getMonth()+1)/3)) : (Math.trunc((now.getMonth()+1)/3))+1;

const total =  groups[`${now.getFullYear()}-Q${currentQuarter}`].length;
console.log(`${minYear}-Q${currentQuarter}`)
  return (
    <Card
      sx={{
        width: size+78,
        height: size,
        p: "19px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        borderRadius: 2,     
      }}
    >
      <Typography
        variant="h4"
        sx={{
          m: -1,
          marginLeft:0,
          flexGrow: 1,
          lineHeight: 1.6,
        }}
      >
        {total}
      </Typography>

      {subtitle && (
        <Typography
          variant="subtitle2"
          sx={{
          }}
        >
          {subtitle} en Q{currentQuarter}
        </Typography>
      )}
    </Card>
  );
};
export default MaintenancesCard;
